import React, { useState } from 'react';
import { Button, Select, TextArea, Field, Modal, useModalClose, ErrorBox, FormActions } from '../../ui/index.js';

// "Uygun değil" (eksik listesi #16): reason labels mirror server DISMISS_REASONS.
export const DISMISS_LABELS = { audience: 'Kitlemize uymuyor', timing: 'Tarihi uymuyor', location: 'Şehri uymuyor', budget: 'Bütçemizi aşar', other: 'Başka bir neden' };

export function DismissDialog({ row, onSave, onDone, onClose: onClosed }) {
  const { open, close: onClose, complete } = useModalClose(onClosed);
  const [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const submit = async event => {
    event.preventDefault(); setError(''); setBusy(true);
    const data = Object.fromEntries(new FormData(event.currentTarget));
    try { await onSave(`/recommendations/${row.recommendationId || row.id}/dismiss`, { method: 'POST', body: { reason: data.reason, note: data.note || '' } }); onClose(); onDone?.(); }
    catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  return <Modal open={open} onOpenChangeComplete={complete} title="Bu öneri uygun değil mi?" description="Öneri listenizden kalkar, silinmez. Ekibimiz nedeninizi görür ve sonraki önerileri buna göre seçer." onClose={onClose}>
    <form className="modal-form" onSubmit={submit}><ErrorBox error={error} />
      <Field label="Neden"><Select name="reason" required placeholder="Bir neden seçin" options={Object.entries(DISMISS_LABELS).map(([value, label]) => ({ value, label }))} /></Field>
      <Field label="Not (isteğe bağlı)"><TextArea name="note" rows={3} maxLength={300} placeholder="Ekibimizin bilmesini istediğiniz bir ayrıntı varsa yazın." /></Field>
      <FormActions><Button type="button" onClick={onClose}>Vazgeç</Button><Button type="submit" variant="solid" color="accent" loading={busy}>Listeden kaldır</Button></FormActions>
    </form>
  </Modal>;
}
